import { Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <FooterBar>
      <div className="topLine" />

      <div className="container">
        <div className="sec aboutus">
          <Typography variant="h2" fontFamily={"Francois One"}>
            Nosotros
          </Typography>

          <Typography component={"p"} fontFamily={"Karla"}>
            Fenabocol ORG (Federación Nacional de Bomberos de Colombia), una
            Institución de socorro sin ánimo de lucro, creada para la atención
            de emergencias como incendios, inundaciones, terremotos, accidentes
            de tránsito, maremotos, tsunamis y todas las demás calamidades
            conexas que se puedan presentar en cualquier lugar del país.
          </Typography>

          <ul className="sci">
            <li>
              <a
                href="https://www.facebook.com/FederacionNacionalDeBomberosDeColombia/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-facebook-f"></i>
              </a>
            </li>
            <li>
              <a
                href="https://tiktok.com/@fenabocolorg"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-tiktok"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/fenabocolorg"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-instagram"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/@fenabocolorg"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>

        <div className="sec quicklinks">
          <Typography variant="h2" fontFamily={"Francois One"}>
            Conoce Más
          </Typography>

          <ul>
            <li>
              <Link to={"/ganacol"}>Ganacol</Link>
            </li>
            <li>
              <Link to={"/contact"}>Contacto</Link>
            </li>
            <li>
              <Link to={"/donations"}>Donaciones</Link>
            </li>
            <li>
              <Link to={"/documents"}>Documentos</Link>
            </li>
            <li>
              <Link to={"/license"}>Licencia</Link>
            </li>
            <li>
              <Link to={"/terms-conditions"}>Términos & Condiciones</Link>
            </li>
          </ul>
        </div>

        <div className="sec quicklinks">
          <Typography variant="h2" fontFamily={"Francois One"}>
            Información
          </Typography>

          <ul>
            <li>
              <p>Fuente de Información: Junta Coordinadora</p>
            </li>
            <li>
              <p>Guionista: Edgar Arturo Fajardo Bernal</p>
            </li>
            <li>
              <p>¡Vincúlate a nosotros!</p>
            </li>
          </ul>
        </div>

        <div className="sec contact">
          <Typography variant="h2" fontFamily={"Francois One"}>
            Contáctanos
          </Typography>

          <ul className="info">
            <li>
              <span>
                <i className="fa-solid fa-location-dot"></i>
              </span>
              <span>
                Bogotá D.C. <br /> Calle 43a sur #78g - 28 <br /> Barrio: Onasis
              </span>
            </li>

            <li>
              <span>
                <i className="fa-solid fa-phone"></i>
              </span>
              <p>
                <a href="tel:3002910614">+57 300 2910614</a> <br />
                <a href="tel:3028575623">+57 302 8575623</a>
              </p>
            </li>

            <li>
              <span>
                <i className="fa-solid fa-envelope"></i>
              </span>
              <p>
                <a href="mailto:fenabocolorg@gmail.com">
                  fenabocolorg@gmail.com
                </a>
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="copyrightText">
        <p>Copyright © {year} Fenabocol ORG. Todos los derechos reservados.</p>
      </div>
    </FooterBar>
  );
};

export default Footer;

const FooterBar = styled.footer`
  position: relative;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  z-index: 0;
  overflow: hidden;

  background: linear-gradient(180deg, #11244f 0%, #1c356d 45%, #142850 100%);
  border-top: 2px solid #d6aa3a;
  box-shadow: 0 -10px 24px rgba(0, 0, 0, 0.18);

  .topLine {
    width: 100%;
    height: 2px;
    background: linear-gradient(
      90deg,
      rgba(214, 170, 58, 0) 0%,
      rgba(214, 170, 58, 0.95) 50%,
      rgba(214, 170, 58, 0) 100%
    );
  }

  .container {
    width: 100%;
    display: grid;
    grid-template-columns: 1.8fr 1fr 1fr 1.2fr;
    gap: 28px;
    padding: 56px 70px 38px;
    box-sizing: border-box;
  }

  .sec {
    h2 {
      position: relative;
      color: #f8f4e8;
      font-size: 1.3rem;
      font-weight: 500;
      margin-bottom: 20px;
      letter-spacing: 0.3px;
      line-height: 1.1;

      &::before {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 56px;
        height: 3px;
        border-radius: 999px;
        background: linear-gradient(90deg, #d6aa3a 0%, #f3cd61 100%);
      }
    }

    p {
      color: rgba(248, 244, 232, 0.88);
      line-height: 1.75;
      font-size: 0.98rem;
      margin: 0;
    }
  }

  .aboutus {
    max-width: 520px;

    .sci {
      margin-top: 24px;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      gap: 12px;

      li {
        list-style: none;

        a {
          width: 46px;
          height: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          border-radius: 12px;

          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(214, 170, 58, 0.22);
          box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.03);
          transition: all 0.25s ease;

          .fa,
          .fa-brands {
            color: #f8f4e8;
            font-size: 18px;
            transition: all 0.25s ease;
          }

          &:hover {
            background: rgba(214, 170, 58, 0.18);
            transform: translateY(-2px);

            .fa,
            .fa-brands {
              color: #f3cd61;
            }
          }
        }
      }
    }
  }

  .quicklinks {
    ul {
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 10px;

      li {
        list-style: none;

        a,
        p {
          color: rgba(248, 244, 232, 0.88);
          text-decoration: none;
          font-size: 0.97rem;
          line-height: 1.6;
          transition: all 0.25s ease;
        }

        a:hover {
          color: #f3cd61;
          padding-left: 4px;
        }

        p {
          margin: 0;
        }
      }
    }
  }

  .contact {
    .info {
      position: relative;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 16px;

      li {
        list-style: none;
        display: grid;
        grid-template-columns: 26px 1fr;
        gap: 12px;
        align-items: start;

        span:nth-child(1) {
          color: #f3cd61;
          font-size: 1rem;
          padding-top: 2px;
        }

        span,
        p {
          color: rgba(248, 244, 232, 0.88);
          margin: 0;
          line-height: 1.6;
        }

        a {
          color: rgba(248, 244, 232, 0.88);
          text-decoration: none;
          transition: color 0.25s ease;

          &:hover {
            color: #f3cd61;
          }
        }
      }
    }
  }

  .copyrightText {
    width: 100%;
    padding: 16px 20px;
    text-align: center;
    box-sizing: border-box;
    background: rgba(8, 16, 36, 0.42);
    border-top: 1px solid rgba(214, 170, 58, 0.16);

    p {
      margin: 0;
      color: rgba(248, 244, 232, 0.82);
      font-size: 0.92rem;
      line-height: 1.5;
    }
  }

  @media (max-width: 1100px) {
    .container {
      padding: 48px 40px 34px;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px 24px;
    }
  }

  @media (max-width: 768px) {
    .container {
      grid-template-columns: 1fr;
      padding: 34px 22px 24px;
      gap: 28px;
    }

    .sec {
      h2 {
        font-size: 1.15rem;
        margin-bottom: 16px;
      }

      p {
        font-size: 0.94rem;
        line-height: 1.65;
      }
    }

    .aboutus {
      .sci {
        gap: 10px;

        li a {
          width: 42px;
          height: 42px;
          border-radius: 10px;
        }
      }
    }

    .quicklinks ul {
      gap: 8px;

      li a,
      li p {
        font-size: 0.94rem;
      }
    }

    .contact .info {
      gap: 14px;

      li {
        grid-template-columns: 24px 1fr;
        gap: 10px;
      }
    }

    .copyrightText {
      padding: 14px 16px;

      p {
        font-size: 0.86rem;
      }
    }
  }
`;